[
  "ARIAActionArgs",
  "ARIATriggeredAction",
  "AckJobSetItemPayload",
  "AckRunQueueItemPayload",
  "AckSlurmCommandPayload",
  "ActiveVariant",
  "ActivityDuration",
  "AddAliasesPayload",
  "AddFilesPayload",
  "AddProjectProtectedAliasesPayload",
  "AddProtectedAliasesPayload",
  "AddPublicQueueLaunchAgentTeamConfigPayload",
  "AddReferenceBucketToTeamPayload",
  "AddRolePermissionsPayload",
  "AddUserToOrganizationPayload",
  "AddWorkflowsAdminPayload",
  "AdvancedRegistryFeatures",
  "AgentConnection",
  "AgentEdge",
  "AgentHeartbeatPayload",
  "AlertCondition",
  "AlertEventConnection",
  "AlertEventEdge",
  "AlertSubscription",
  "ApiKeyConnection",
  "ApiKeyEdge",
  "ArtifactAction",
  "ArtifactActionConnection",
  "ArtifactActionEdge",
  "ArtifactAliasAction",
  "ArtifactAliasActionConnection",
  "ArtifactAliasActionEdge",
  "ArtifactAliasConnection",
  "ArtifactAliasEdge",
  "ArtifactAliasEventDetails",
  "ArtifactCollection",
  "ArtifactCollectionActionConnection",
  "ArtifactCollectionActionEdge",
  "ArtifactCollectionAlias",
  "ArtifactCollectionConnection",
  "ArtifactCollectionEdge",
  "ArtifactCollectionMembershipConnection",
  "ArtifactCollectionMembershipEdge",
  "ArtifactCollectionOverview",
  "ArtifactCollectionOverviewMetricCandidate",
  "ArtifactCollectionOverviewMetricCandidatePacket",
  "ArtifactCollectionOverviewVersionCandidate",
  "ArtifactCollectionOverviewVersionCandidatePacket",
  "ArtifactCollectionSearchConnection",
  "ArtifactCollectionSearchEdge",
  "ArtifactConnection",
  "ArtifactConnectionType",
  "ArtifactEdge",
  "ArtifactEdgeType",
  "ArtifactEventDetails",
  "ArtifactLineageDag",
  "ArtifactLineageDagEdge",
  "ArtifactLineageDagRun",
  "ArtifactManifestConnection",
  "ArtifactManifestEdge",
  "ArtifactMetricSearchResult",
  "ArtifactMetricValue",
  "ArtifactSequenceConnection",
  "ArtifactSequenceEdge",
  "ArtifactSequenceStorageNodeConnection",
  "ArtifactSequenceStorageNodeEdge",
  "ArtifactStorageNodeConnection",
  "ArtifactStorageNodeEdge",
  "ArtifactTagEventDetails",
  "ArtifactTypeConnection",
  "ArtifactTypeEdge",
  "ArtifactTypeNameConnection",
  "ArtifactTypeNameEdge",
  "ArtifactUsageLimitStatus",
  "ArtifactWeaveSource",
  "AttachCustomerPaymentMethodPayload",
  "BenchmarkRunConnection",
  "BenchmarkRunEdge",
  "BucketDiff",
  "BucketDiffs",
  "BucketStoreConnectionError",
  "BucketType",
  "CancelCustomerSubscriptionPayload",
  "CancelPaygoSubscriptionsPayload",
  "CheckoutPreview",
  "CheckoutPreviewLineItemsMetadata",
  "CheckoutPreviewSubLineItemsMetadata",
  "ClaimAnonymousEntityPayload",
  "ClaimSlurmCommandsPayload",
  "ClientIDMapping",
  "ClientIDMappingEntry",
  "CloneProjectsPayload",
  "Code",
  "CollectionTagEventDetails",
  "CommitArtifactPayload",
  "CompleteMultipartUploadArtifactPayload",
  "ContactUsForComputeHoursPayload",
  "ContactUsForUserLedTrialPayload",
  "CoreweaveInfo",
  "CreateAcademicOrReverseTrialPayload",
  "CreateAccessTokenPayload",
  "CreateAgentPayload",
  "CreateAlertPayload",
  "CreateAlertThresholdPayload",
  "CreateArtifactCollectionPayload",
  "CreateArtifactFilesPayload",
  "CreateArtifactManifestPayload",
  "CreateArtifactPayload",
  "CreateArtifactTypePayload",
  "CreateArtifactTypesPayload",
  "CreateClientIDMappingPayload",
  "CreateClientPayload",
  "CreateCustomChartPayload",
  "CreateCustomerSubscriptionPayload",
  "CreateCustomerTrialPayload",
  "CreateDefaultResourceConfigPayload",
  "CreateDiscussionCommentPayload",
  "CreateDiscussionThreadPayload",
  "CreateEmailSubscriptionPayload",
  "CreateEntityPayload",
  "CreateFilterTriggerPayload",
  "CreateGlueTaskPayload",
  "CreateHourOverageSubscriptionPayload",
  "CreateInferenceSubscriptionPayload",
  "CreateIntegrationPayload",
  "CreateInvitePayload",
  "CreateLaunchAgentPayload",
  "CreateLocalLicenseOrganizationPayload",
  "CreateNewsletterSubscriptionPayload",
  "CreateNotebookPayload",
  "CreateOAuthProviderPayload",
  "CreateOrgServiceAccountPayload",
  "CreatePreviewableLinkPayload",
  "CreatePricingPlanUpdatePRPayload",
  "CreateProjectMembersPayload",
  "CreateProjectPayload",
  "CreateRegistryHuggingFaceImportPayload",
  "CreateRegistryModelDeploymentPayload",
  "CreateRolePayload",
  "CreateRunFilesPayload",
  "CreateRunQueuePayload",
  "CreateSandboxPermissionPayload",
  "CreateSandboxesSubscriptionPayload",
  "CreateSemanticLegendPayload",
  "CreateServiceAccountApiKeyPayload",
  "CreateServiceAccountPayload",
  "CreateSlackChannelSubscriptionPayload",
  "CreateStorageSubscriptionPayload",
  "CreateTagsPayload",
  "CreateTeamPayload",
  "CreateUserEmailPayload",
  "CreateUserLevelSlackIntegrationPayload",
  "CreateUserPayload",
  "CreateViewDiscussionCommentPayload",
  "CustomChartConnection",
  "CustomChartEdge",
  "CustomColor",
  "DefaultResourceConfigConnection",
  "DefaultResourceConfigEdge",
  "DefaultResourceConfigScope",
  "DefaultTriggerResultDetails",
  "DeleteAlertPayload",
  "DeleteAlertSubscriptionPayload",
  "DeleteAlertThresholdPayload",
  "DeleteAliasesPayload",
  "DeleteApiKeyPayload",
  "DeleteApiKeysPayload",
  "DeleteArtifactByWeaveRefPayload",
  "DeleteArtifactCollectionPayload",
  "DeleteArtifactEntityTTLPayload",
  "DeleteArtifactPayload",
  "DeleteCustomChartPayload",
  "DeleteDefaultResourceConfigsPayload",
  "DeleteDiscussionCommentPayload",
  "DeleteFilesPayload",
  "DeleteFromRunQueuePayload",
  "DeleteGlueTaskPayload",
  "DeleteIntegrationPayload",
  "DeleteInvitePayload",
  "DeleteLaunchAgentsPayload",
  "DeleteModelPayload",
  "DeleteNotebookPayload",
  "DeleteOAuthProviderPayload",
  "DeleteOrganizationPayload",
  "DeleteOrganizationSubscriptionPayload",
  "DeleteProjectMembersPayload",
  "DeletePublicQueueLaunchAgentTeamConfigPayload",
  "DeleteRolePayload",
  "DeleteRolePermissionsPayload",
  "DeleteRunPayload",
  "DeleteRunQueuesPayload",
  "DeleteRunsPayload",
  "DeleteSecretPayload",
  "DeleteServiceAccountApiKeyPayload",
  "DeleteServiceAccountPayload",
  "DeleteSweepsPayload",
  "DeleteTagAssignmentPayload",
  "DeleteTeamPayload",
  "DeleteTeamSecretPayload",
  "DeleteTriggerPayload",
  "DeleteUserEmailPayload",
  "DeleteUserLevelSlackIntegrationPayload",
  "DeleteUserPayload",
  "DeleteUserSecretPayload",
  "DeleteViewPayload",
  "DeleteViewsPayload",
  "DeleteWorkflowsAdminPayload",
  "DeleteWorkspaceTemplatePayload",
  "DeletedRunConnection",
  "DeletedRunEdge",
  "DeletedRunInfo",
  "DetachCustomerPaymentMethodPayload",
  "DisableGlueTaskPayload",
  "DisableOldTrackingSubscriptionPayload",
  "Discount",
  "DiscussionCommentConnection",
  "DiscussionCommentEdge",
  "DiscussionThreadConnection",
  "DiscussionThreadEdge",
  "DuplicateNotebookPayload",
  "DynamicConfig",
  "EnableGlueTaskPayload",
  "EnqueueSweepRunPayload",
  "EnsureSandboxesOverageSubscriptionPayload",
  "EnsureWbagentOverageSubscriptionPayload",
  "EntityConnection",
  "EntityEdge",
  "EntitySettings",
  "EntityUsage",
  "EntityUserConnection",
  "EntityUserEdge",
  "Error",
  "Event",
  "EventEdge",
  "ExecuteTriggerPayload",
  "ExpansionPackConnection",
  "ExpansionPackEdge",
  "FailRunQueueItemPayload",
  "FailSlurmCommandPayload",
  "FailedPaymentBanners",
  "FeatureFlag",
  "FileConnection",
  "FileEdge",
  "FileStorageNodeConnection",
  "FileStorageNodeEdge",
  "FileSystemSnapshot",
  "FileSystemSnapshotConnection",
  "FileSystemSnapshotEdge",
  "FilterEventTriggeringCondition",
  "FinishedRunCondition",
  "FolderMetadata",
  "Folders",
  "ForceCleanArtifactStorageStatsPayload",
  "ForceCleanRunStorageStatsPayload",
  "GenerateApiKeyPayload",
  "GenerateArtifactCollectionOverviewDraftPayload",
  "GenerateLocalLicensePayload",
  "GenericWebhookActionArgs",
  "GenericWebhookTriggeredAction",
  "GitInfo",
  "GlueManager",
  "GlueRunConnection",
  "GlueRunEdge",
  "GlueTaskConfig",
  "GlueTaskConnection",
  "GlueTaskEdge",
  "GrantPersonalSecretToWBAgentPayload",
  "GroupBucketDiff",
  "GroupBucketDiffs",
  "GroupedRunConnection",
  "GroupedRunEdge",
  "HeartbeatSandboxPayload",
  "HttpTriggerResultDetails",
  "ImageUrl",
  "InferenceCostUsageAggregation",
  "InferenceEnterpriseSubscription",
  "IngestionHealth",
  "Initiator",
  "InputArtifactConnection",
  "InputArtifactEdge",
  "InsertGalleryDiscussionPayload",
  "InsertSecretPayload",
  "Integration",
  "IntegrationConnection",
  "IntegrationEdge",
  "InviteConnection",
  "InviteEdge",
  "JobSetDiff",
  "LeaseJobSetItemPayload",
  "LicenseClaims",
  "LicenseExpirationUI",
  "LinkArtifactPayload",
  "LinkTeamToOrganizationPayload",
  "LocalVersionInfo",
  "LogExperimentExposurePayload",
  "LogLine",
  "LogLineConnection",
  "LogLineEdge",
  "MakeOrgMembersNoAccessModelsSeatPayload",
  "MarkRunFilesUploadedPayload",
  "MaybeGroupedRunConnection",
  "Member",
  "MetricInfo",
  "MetricSearchResults",
  "MigrateOldHourOverageSubscriptionPayload",
  "MigrateOldStorageSubscriptionPayload",
  "MigrateOrPurgePersonalEntityPayload",
  "ModelRegistryMigrationConfig",
  "ModifyRunsPayload",
  "MoveArtifactCollectionPayload",
  "MoveHistoryForRunPayload",
  "MoveProjectsPayload",
  "MoveRunsPayload",
  "MoveViewPayload",
  "MultiValueMetadataColumn",
  "NewsletterSubscriptionConnection",
  "NewsletterSubscriptionEdge",
  "NoOpActionArgs",
  "NoOpTriggeredAction",
  "Node",
  "NodeAlert",
  "NotebookConnection",
  "NotebookEdge",
  "NotebookQuota",
  "NotebookVersionRef",
  "NotificationTriggeredAction",
  "NotifyScriptableRunAlertPayload",
  "OrgActivityTimeline",
  "OrgDashboardActiveUsersForRangeStats",
  "OrganizationApiKeyConnection",
  "OrganizationApiKeyEdge",
  "OrganizationConnection",
  "OrganizationEdge",
  "OrganizationSeatAvailability",
  "PageInfo",
  "ParquetHistory",
  "PaymentMetadata",
  "PopFromRunQueuePayload",
  "ProjectConnection",
  "ProjectEdge",
  "ProjectField",
  "ProjectFieldConnection",
  "ProjectFieldEdge",
  "ProjectIcon",
  "ProjectPermissions",
  "ProjectStorageNodeConnection",
  "ProjectStorageNodeEdge",
  "ProjectTeamMember",
  "ProtectedArtifactAlias",
  "PublicImageUploadInfo",
  "PublishBenchmarkRunPayload",
  "PurgeUserPayload",
  "PushNotificationActionArgs",
  "PushNotificationTriggerResultDetails",
  "PushNotificationTriggeredAction",
  "PushToRunQueueByNamePayload",
  "PushToRunQueuePayload",
  "QueueJobActionArgs",
  "QueueJobTriggeredAction",
  "QueuedJobTriggerResultDetails",
  "RampManager",
  "RampSettingConnection",
  "RampSettingEdge",
  "RampSettingThreshold",
  "RampThresholdStore",
  "RateLimits",
  "ReactivateCustomerSubscriptionPayload",
  "RecordSlurmCommandErrorPayload",
  "ReferenceBucketDownloadUrlsPayload",
  "RegisterUserDevicePayload",
  "RegistryAsset",
  "RegistryHuggingFaceImportConnection",
  "RegistryHuggingFaceImportEdge",
  "RegistryHuggingFaceImportEventConnection",
  "RegistryHuggingFaceImportEventEdge",
  "RegistryModelDeploymentConnection",
  "RegistryModelDeploymentEdge",
  "RegistryModelDeploymentEventConnection",
  "RegistryModelDeploymentEventEdge",
  "RegistryModelDeploymentSandboxWorkloadConnection",
  "RegistryModelDeploymentSandboxWorkloadEdge",
  "RemoteScoringAllowedHost",
  "RemoteScoringPolicy",
  "RemoveProjectProtectedAliasesPayload",
  "RemoveProtectedAliasesPayload",
  "RemoveUserFromOrganizationByIdPayload",
  "RemoveUserFromOrganizationPayload",
  "RenameNotebookPayload",
  "RepoConnection",
  "RepoEdge",
  "RepoInsightsRowConnection",
  "ResendEmailVerificationPayload",
  "ResetPasswordPayload",
  "ResumePaygoSubscriptionsPayload",
  "RetryStripeOpenInvoicesByOrganizationPayload",
  "RevokeAccessTokenEmailPayload",
  "RevokeAccessTokenPayload",
  "RevokeClientPayload",
  "RevokePersonalSecretFromWBAgentPayload",
  "RewindRunPayload",
  "Role",
  "RolePermission",
  "RowConnection",
  "RowEdge",
  "RowType",
  "RunAlertChannelPrefs",
  "RunBranchPoint",
  "RunConnection",
  "RunCrashedChannelPrefs",
  "RunDescendantRuns",
  "RunDiff",
  "RunEdge",
  "RunFieldValue",
  "RunFieldValueConnection",
  "RunFieldValueEdge",
  "RunInfo",
  "RunKeySuggestion",
  "RunMetricEventDetails",
  "RunQueueItemConnection",
  "RunQueueItemEdge",
  "RunQueueItemInfoDetails",
  "RunSelectorGroupConnection",
  "RunSelectorGroupEdge",
  "RunServicesAvailable",
  "RunSlurmControl",
  "RunStateEventDetails",
  "RunStorageNodeConnection",
  "RunStorageNodeEdge",
  "RunTagConnection",
  "RunTagCount",
  "RunTagEdge",
  "RunsResult",
  "Sandbox",
  "SandboxCIDRBlock",
  "SandboxConnection",
  "SandboxContainerStatus",
  "SandboxEdge",
  "SandboxEgressRule",
  "SandboxEndpointSpec",
  "SandboxEndpointStatus",
  "SandboxEnvVars",
  "SandboxGPU",
  "SandboxIngressRule",
  "SandboxLabel",
  "SandboxLogConnection",
  "SandboxLogEntry",
  "SandboxNetworkOptions",
  "SandboxObservedStatus",
  "SandboxPortRangeV1",
  "SandboxResourceRequirements",
  "SandboxResources",
  "SandboxSelectorBlock",
  "SandboxServiceSpec",
  "SandboxServiceStatus",
  "SandboxSpec",
  "SandboxV1ResourceUsage",
  "SandboxesEnterpriseSubscription",
  "ScriptableRunCondition",
  "Secret",
  "SectionAwareHistoryKeyPrefixGroup",
  "SectionAwareHistoryKeyTypeCategoryGroup",
  "SectionAwareHistoryKeysResults",
  "SemanticLegend",
  "SemanticLegendByMetric",
  "ServerFeature",
  "ServerInfo",
  "SetDismissedBannerPayload",
  "SetSandboxEnvVarsPayload",
  "SetTagColorPayload",
  "SlackNotificationActionArgs",
  "SlurmDaemonHealth",
  "SlurmInfo",
  "StarProjectPayload",
  "StarRegistryPayload",
  "StarViewPayload",
  "StargazerConnection",
  "StargazerEdge",
  "StopRegistryModelDeploymentPayload",
  "StopRunPayload",
  "StoppedRunCondition",
  "StorageBucketInfo",
  "StorageTreeNode",
  "StripeBillingInfo",
  "StripeInvoice",
  "StripePaymentMethod",
  "StripePaymentMethodCard",
  "StripePrice",
  "StripeSubscription",
  "SubmitBenchmarkRunPayload",
  "SubmitFCNewsPayload",
  "SubmitSlurmCommandPayload",
  "SweepConnection",
  "SweepEdge",
  "TagConnection",
  "TagEdge",
  "TagGroup",
  "TagNameConnection",
  "TagNameEdge",
  "TaggedObject",
  "TaggedObjectConnection",
  "TaggedObjectEdge",
  "TemplateVariable",
  "TerminateSandboxPayload",
  "TestGenericWebhookIntegrationPayload",
  "Thumbnail",
  "TrainingCostUsageAggregation",
  "TriggerActionDetails",
  "TriggerConnection",
  "TriggerEdge",
  "TriggerEventDetails",
  "TriggerEventsExportPayload",
  "TriggerExecutionAction",
  "TriggerExecutionConnection",
  "TriggerExecutionEdge",
  "TriggerExecutionError",
  "TriggerExecutionEvent",
  "TriggerExecutionResult",
  "TriggerFlatRunsMigratorPayload",
  "TriggerParquetExportPayload",
  "TriggerRecomputeKeysInfoPayload",
  "TriggerRecomputeSystemMetricsPayload",
  "TriggerResultDetails",
  "TriggerScope",
  "TriggerTemplateVariable",
  "TriggeredAction",
  "TriggeringCondition",
  "UndeleteProjectPayload",
  "UndeleteRunsPayload",
  "UndeleteUserPayload",
  "UnlinkArtifactPayload",
  "UnlinkNvidiaAccountPayload",
  "UnregisterUserDevicePayload",
  "UnstarProjectPayload",
  "UnstarRegistryPayload",
  "UnstarViewPayload",
  "UpdateAccessTokenPayload",
  "UpdateAccessTokenProjectsPayload",
  "UpdateAlertPayload",
  "UpdateAlertThresholdPayload",
  "UpdateApiKeyPayload",
  "UpdateArtifactCollectionPayload",
  "UpdateArtifactEntityTTLPayload",
  "UpdateArtifactManifestPayload",
  "UpdateArtifactPayload",
  "UpdateArtifactTypePayload",
  "UpdateBenchmarkRunPayload",
  "UpdateCustomChartPayload",
  "UpdateCustomerDefaultPaymentMethodPayload",
  "UpdateCustomerPaymentMethodPayload",
  "UpdateDefaultResourceConfigPayload",
  "UpdateDiscussionCommentPayload",
  "UpdateDiscussionThreadPayload",
  "UpdateEntityPayload",
  "UpdateFilterTriggerPayload",
  "UpdateGlueTaskPayload",
  "UpdateLaunchAgentPayload",
  "UpdateLocalLicensePayload",
  "UpdateMemberPayload",
  "UpdateModelsSeatPayload",
  "UpdateOrganizationBillingUserPayload",
  "UpdateOrganizationPayload",
  "UpdateOrganizationPrivacySettingsPayload",
  "UpdateOrganizationRemoteScoringSettingsPayload",
  "UpdateOrganizationSubscriptionPayload",
  "UpdateOrganizationSubscriptionSeatsPayload",
  "UpdateOrganizationUserPayload",
  "UpdateOrganizationUserV2Payload",
  "UpdateProjectLastActivePayload",
  "UpdateProjectMemberPayload",
  "UpdateProjectTeamMemberPayload",
  "UpdateRampThresholdPayload",
  "UpdateRolePayload",
  "UpdateRunQueueItemWarningPayload",
  "UpdateRunQueuePayload",
  "UpdateRunStatePayload",
  "UpdateSemanticLegendPayload",
  "UpdateServiceAccountApiKeyPayload",
  "UpdateSlurmDaemonHeartbeatPayload",
  "UpdateSubscriptionPayload",
  "UpdateTagCategoryPayload",
  "UpdateTagPayload",
  "UpdateUserEmailPayload",
  "UpdateUserLevelAlertPreferencesPayload",
  "UpdateUserPayload",
  "UpdateUserRolePayload",
  "UpdateUserRoleV2Payload",
  "UpdateWeaveRolePayload",
  "UpgradeCustomerSubscriptionPayload",
  "UpgradeTrialSubscriptionPayload",
  "UploadMultipartUrls",
  "UploadPanelPayload",
  "UploadUrlPart",
  "UpsertBucketPayload",
  "UpsertModelPayload",
  "UpsertRunGroupPayload",
  "UpsertRunQueuePayload",
  "UpsertSharedViewPayload",
  "UpsertSweepPayload",
  "UpsertTeamSecretPayload",
  "UpsertUserProfileViewPayload",
  "UpsertUserSecretPayload",
  "UpsertViewPayload",
  "UpsertWorkspaceTemplatePayload",
  "UpsertedSecret",
  "UsageAggregation",
  "UsageAggregationInterface",
  "UsageByPeriodResponse",
  "UsageInterval",
  "UsageStat",
  "UsageStatConnection",
  "UsageStatEdge",
  "UseArtifactPayload",
  "UserActivityDetails",
  "UserConnection",
  "UserEdge",
  "UserLevelAlertPreferences",
  "UserLevelAlerts",
  "UserSecret",
  "Variant",
  "VersionedArtifactConnection",
  "VersionedArtifactEdge",
  "ViewConnection",
  "ViewEdge",
  "ViewViewPayload",
  "WBAgentPersonalSecretGrant",
  "WeaveEnterpriseSubscription",
  "WeaveLimits",
  "WeaveMetricThresholdEventDetails",
  "WeaveSavingsCalculator",
  "upgradeCustomerToProPlanPayload",
  "upgradeProCustomerPayload"
]
